import React, { useState } from "react";
import { loginAdmin } from "./api";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, Mail, Lock } from "lucide-react";

function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    const result = await loginAdmin(email, password);
    if (result.status === "success") {
      localStorage.setItem("admin", "true");
      navigate("/admin/dashboard");
    } else {
      setError(result.message);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "100vh",
        background: "linear-gradient(135deg, rgb(17 181 203) 0%, rgb(37, 117, 252) 100%)",
        fontFamily: "'Poppins', sans-serif",
      }}
    >
      <div
        className="p-5 shadow-lg"
        style={{
          width: "100%",
          maxWidth: "420px",
          background: "rgba(255, 255, 255, 0.1)",
          borderRadius: "20px",
          backdropFilter: "blur(14px)",
          WebkitBackdropFilter: "blur(14px)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          color: "#fff",
        }}
      >
        <h2 className="text-center mb-4 fw-bold">🔒 Admin Portal</h2>

        {error && (
          <div className="alert alert-danger p-2 text-center" style={{ fontSize: "14px" }}>
            {error}
          </div>
        )}

        <div className="mb-3 position-relative">
          <label className="form-label">Email</label>
          <div className="position-relative">
            <input
              type="email"
              className="form-control rounded-pill ps-5"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@example.com"
              style={{ backgroundColor: "rgba(255,255,255,0.2)", color: "#fff", border: "none" }}
            />
            <Mail
              size={18}
              style={{
                position: "absolute",
                top: "50%",
                left: "15px",
                transform: "translateY(-50%)",
                color: "#ccc",
              }}
            />
          </div>
        </div>

        <div className="mb-4 position-relative">
          <label className="form-label">Password</label>
          <div className="position-relative">
            <input
              type={showPassword ? "text" : "password"}
              className="form-control rounded-pill ps-5 pe-5"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              style={{ backgroundColor: "rgba(255,255,255,0.2)", color: "#fff", border: "none" }}
            />
            <Lock
              size={18}
              style={{
                position: "absolute",
                top: "50%",
                left: "15px",
                transform: "translateY(-50%)",
                color: "#ccc",
              }}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              style={{
                position: "absolute",
                top: "50%",
                right: "15px",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                color: "#ccc",
                cursor: "pointer",
              }}
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        <button
          className="btn w-100 rounded-pill fw-semibold"
          onClick={handleLogin}
          style={{
            backgroundColor: "#fff",
            color: "#2575fc",
            transition: "all 0.3s ease-in-out",
          }}
          onMouseEnter={(e) => (e.target.style.backgroundColor = "#2575fc", e.target.style.color = "#fff")}
          onMouseLeave={(e) => (e.target.style.backgroundColor = "#fff", e.target.style.color = "#2575fc")}
        >
          Login
        </button>
      </div>
    </div>
  );
}

export default AdminLogin;
